import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const verifyPayment = createAsyncThunk('verifyPayment/verifyPayment', async (data) => {
    const { razorpay_order_id, razorpay_payment_id, razorpay_signature, link_id } = data;
    try {
        const res = await axios({
            method: 'POST',
            url: process.env.REACT_APP_API_URL + `verify_payment`,
            data: {
                razorpay_order_id: razorpay_order_id,
                razorpay_payment_id: razorpay_payment_id,
                razorpay_signature: razorpay_signature,
                link_id: link_id
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

